import useConditionalEffect from 'hooks/useConditionalEffect'
import { Feed, Stream } from 'interfaces'
import { FC, ReactNode, useCallback, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { Subscription, animationFrameScheduler, from, of } from 'rxjs'
import { mergeMap, observeOn } from 'rxjs/operators'
import { getStreams } from 'services/content/streams/actions'
import { StoreThunkDispatch } from 'store/state'

export interface FetchMyStreamsProps {
  forceFetch?: boolean
  onFetched({ streams, feeds }: { streams: Stream[], feeds: Feed[] }): void
  onFailed?(err: any): void
  children?: ReactNode
}

const FetchMyStreams: FC<FetchMyStreamsProps> = ({
  forceFetch = true,
  onFetched,
  onFailed,
  children
}) => {
  const dispatch = useDispatch() as StoreThunkDispatch
  const subscriptionRef = useRef<Subscription | null>(null)

  const handleFailed = useCallback((err: any) => {
    console.log(err)
    if (onFailed) {
      onFailed(err)
    }
  }, [onFailed])

  const fetch = useCallback(() => {
    return from(dispatch(getStreams(forceFetch)).unwrap())
      .pipe(
        mergeMap((streams) => {
          return of({ streams })
        }),
        observeOn(animationFrameScheduler)
      )
      .subscribe({ next: onFetched, error: handleFailed })
  }, [dispatch, forceFetch, onFetched, handleFailed])

  useConditionalEffect(([_fetch]) => {
    subscriptionRef.current = _fetch()

    return () => {
      subscriptionRef.current?.unsubscribe()
    }
  }, [], [fetch])

  return children || null
}

export default FetchMyStreams
